import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from 'semantic-ui-react';
import './VirtualTryOnProcessingModal.css';

const VirtualTryOnProcessingModal = ({
  isOpen,
  progress = 0,
  message = 'Processing virtual try-on...',
  onCancel,
  creditBalance = null,
  creditsUsed = null, // null = pending/unknown, 0 = cached, 1+ = credits used
  isCached = false
}) => {
  if (!isOpen) return null;

  // Only calculate remaining if we know credits used
  const remainingCredits = (creditBalance !== null && creditsUsed !== null)
    ? Math.max(0, creditBalance - creditsUsed)
    : null;

  const modalContent = (
    <div className="virtual-try-on-processing-modal-overlay">
      <div className="virtual-try-on-processing-modal">
        <div className="processing-modal-content">
          <div className="processing-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-inner">
              <span className="processing-icon"><Icon name="heart" style={{ margin: 0, fontSize: '28px', color: 'white' }} /></span>
            </div>
          </div>

          <h3 className="processing-title">Virtual Try-On</h3>
          <p className="processing-message">{message}</p>

          {creditBalance !== null && (
            <div className="processing-credits">
              {creditsUsed === null ? (
                <span className="credits-pending">Checking cache...</span>
              ) : isCached || creditsUsed === 0 ? (
                <>
                  <span className="credits-cached"><Icon name="checkmark" size="small" /> Using cached result</span>
                  <span className="credits-remaining">Credits: {creditBalance}</span>
                </>
              ) : (
                <>
                  <span className="credits-used">Credits used: {creditsUsed}</span>
                  <span className="credits-remaining">Remaining: {remainingCredits}</span>
                </>
              )}
            </div>
          )}

          <div className="processing-progress">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${Math.max(10, progress)}%` }}
              ></div>
            </div>
            <span className="progress-text">{Math.round(progress)}%</span>
          </div>

          {/* <div className="processing-tips">
            <p><Icon name="magic" size="small" style={{ marginRight: '4px' }} />Creating your perfect look...</p>
          </div> */}

          {onCancel && (
            <button className="processing-cancel" onClick={onCancel}>
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );

  // Use portal to render at document root level
  return ReactDOM.createPortal(modalContent, document.body);
};

export default VirtualTryOnProcessingModal;